import { render, staticRenderFns } from "./CustomViewCardDialog.vue?vue&type=template&id=274908d4&"
import script from "./CustomViewCardDialog.vue?vue&type=script&lang=js&"
export * from "./CustomViewCardDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports